/**
 * Feature flag for the Project Evaluation Form V2.
 *
 * V2 is off by default in production. Enable via one of:
 *  - Build-time env: `VITE_INTAKE_V2_ENABLED=true`
 *  - URL override (review only): `?intake_v2=1` (persisted for session)
 *
 * V1 remains the untouched default until this returns true.
 */
export function intakeV2Enabled(): boolean {
  try {
    const envFlag =
      (import.meta as unknown as { env?: Record<string, string> }).env
        ?.VITE_INTAKE_V2_ENABLED === "true";
    if (envFlag) return true;
    if (typeof window === "undefined") return false;
    const qs = new URLSearchParams(window.location.search);
    if (qs.get("intake_v2") === "1") {
      sessionStorage.setItem("intake_v2", "1");
      return true;
    }
    if (qs.get("intake_v2") === "0") {
      sessionStorage.removeItem("intake_v2");
      return false;
    }
    return sessionStorage.getItem("intake_v2") === "1";
  } catch {
    return false;
  }
}
